import React from 'react'
import { compact } from 'lodash'

import css from './style.scss'

const PageSidebar = (props) => (
  <aside className={css.sidebar}>
    <div className={compact([css.tableOverride, props.narrow ? css.narrow : '']).join(' ')}>
      {props.children}
    </div>
  </aside>
)

PageSidebar.propTypes = {
  children: React.PropTypes.node,
  // Opt-in narrower sidebar (~25% off), for pages that want more room in the
  // main column. Desktop/laptop only — this component's width is already
  // fixed-only above the tablet breakpoint, so there's nothing to opt out of
  // on mobile.
  narrow: React.PropTypes.bool
}

export default PageSidebar
